import conversionUtcDate from 'src/utils/conversionUtcDate'
import { getGcloudAll } from '/src/@api/dashboard'
import { createDeviceScopedChatSlice } from 'src/store/apps/createDeviceScopedChatSlice'

const readDeviceSnapshot = () => ({
  deviceUser: JSON.parse(localStorage.getItem('DeviceUser') || '{}'),
  currentDevice: JSON.parse(localStorage.getItem('currentDevice') || '{}')
})

const mapDetail = item => ({
  ...item,
  time: conversionUtcDate(item.date, 'local', 'YYYY-MM-DD HH:mm'),
  defaultAvata: '/images/avatars/10.png'
})

const loadSummary = async ({ page }) => {
  const { deviceUser, currentDevice } = readDeviceSnapshot()
  const username = deviceUser?.username || ''
  const deviceUdid = currentDevice?.['Unique Identifier'] || ''
  const response = await getGcloudAll({
    username,
    params: { category: 'WHATSAPP_SUMMARY', offset: (page - 1) * 50, limit: 50, deviceUdid }
  })
  const data = response.data.contents?.map(item => ({
    ...item,
    time: conversionUtcDate(item.snippetTimestamp, 'local', 'YYYY-MM-DD'),
    defaultAvata: '/images/avatars/10.png'
  })) || []
  let defaultSelectData = []
  if (page === 1 && data[0]) {
    const detail = await getGcloudAll({
      username,
      params: { category: 'WHATSAPP_DETAIL', offset: 0, limit: 50, deviceUdid, rid: String(data[0].chatid) }
    })
    defaultSelectData = detail.data.contents?.map(mapDetail) || []
  }

  return { data, defaultSelectData, leftTotalCount: response.data.totalCount }
}

const loadDetail = async ({ contact, page }) => {
  const { deviceUser, currentDevice } = readDeviceSnapshot()
  const response = await getGcloudAll({
    username: deviceUser?.username || '',
    params: {
      category: 'WHATSAPP_DETAIL',
      offset: (page - 1) * 50,
      limit: 50,
      deviceUdid: currentDevice?.['Unique Identifier'] || '',
      rid: String(contact.chatid)
    }
  })

  return {
    selected: response.data.contents?.map(mapDetail) || [],
    rightTotalCount: response.data.totalCount
  }
}

const chat = createDeviceScopedChatSlice({
  sliceName: 'androidWhatsapp',
  storeKey: 'androidWhatsapp',
  actionPrefix: 'androidWhatsapp',
  contactKey: 'chatid',
  storageKey: 'androidWhatsappItem',
  loadSummary,
  loadDetail,
  createExtraState: () => ({ preViewImage: { open: false, url: '' } })
})

export const fetchUserProfile = chat.fetchSummary
export const selectMessage = chat.selectDetail
export const setPerViewImage = chat.setPerViewImage
export const removeSelectedChat = chat.removeSelectedChat
export default chat.reducer
